import { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

import { Flex } from '@revenuemarket/cds';
import { ICellEditorComp } from 'ag-grid-community';
import { CustomCellEditorProps } from 'ag-grid-react';

import BankSelector from '~components/BankWiring/BankSelector';

interface Props extends CustomCellEditorProps<any, number> {}

const AGGridBankEditor = (
  { data, value, api, column, node, onValueChange }: Props,
  ref: ForwardedRef<ICellEditorComp>,
) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState(true);
  const [innerValue, setInnerValue] = useState(value ?? undefined);

  useImperativeHandle(
    ref,
    () => ({
      getGui: () => containerRef.current ?? document.body,
      getValue: () => innerValue,
      init: (params) => {
        setInnerValue(params.value);
      },
    }),
    [innerValue],
  );

  useEffect(() => {
    if (!open) {
      api.stopEditing(false);
      api.setFocusedCell(node.rowIndex as number, column);
    }
  }, [api, column, node.rowIndex, open]);

  return (
    <Flex ref={containerRef} align="center" style={{ height: '100%' }}>
      <BankSelector
        open={open}
        value={innerValue}
        onChange={(value) => {
          setInnerValue(value);
          onValueChange?.(value);
          setTimeout(() => {
            setOpen(false);
            api.clearFocusedCell();
          }, 500);
        }}
      />
    </Flex>
  );
};

export default forwardRef(AGGridBankEditor);
